import React, { useState, useEffect, useRef } from 'react';
import Logo from '../../components/Logo/Logo';
import stylePreventivatore from './Preventivatore.module.scss';
import stylesForm from '../Steps/Form/Form.module.scss';
import {Form, Select, Slider, Switch, Modal, Collapse } from 'antd';
import Preventivo from '../../components/Preventivo/Preventivo';
import { useDispatch, useSelector } from 'react-redux';
import getCalcoloPreventivo from '../../redux/actions/mock/getCalcoloPreventivo';
import inserimentoPreventivo from '../../redux/actions/mock/inserimentoPreventivo';
// import { saveCookie, getCookie } from '../../redux/actions/mock/adtractionCookie';
import * as actionTypes from '../../redux/actions/actionTypes';
import Immagine from '../../components/Immagine/Immagine';
import parse from 'html-react-parser';

const { Panel } = Collapse;

const Preventivatore = () => {

    const uuid = useSelector(state => state.dataReducer.modello.id);
    const numPratica = useSelector(state => state.dataReducer.modello.numPratica);
    const codiceBroker = useSelector(state => state.dataReducer.modello.codiceBroker);
    const stepCorrente = useSelector(state => state.dataReducer.modello.currentStep);
    const apiPath = useSelector(state => state.dataReducer.dataApiPath);


    const documentiPreventivatore = useSelector(state => state.dataReducer.documentiPdf.documentiPreventivatore);
    const linkTrasparenza = useSelector(state => state.dataReducer.documentiPdf.linkTrasparenza);
    const linkSicurezza = useSelector(state => state.dataReducer.documentiPdf.linkSicurezza);
    const linkCookies = useSelector(state => state.dataReducer.documentiPdf.linkCookies);
    const linkPrivacy = useSelector(state => state.dataReducer.documentiPdf.linkPrivacy);
    const linkHome = useSelector(state => state.dataReducer.documentiPdf.linkHome);
    const docAssicurazione1 = useSelector(state => state.dataReducer.documentiPdf.docAssicurazione1);
    const docAssicurazione2 = useSelector(state => state.dataReducer.documentiPdf.docAssicurazione2);
    const docAssicurazione3 = useSelector(state => state.dataReducer.documentiPdf.docAssicurazione3);
    const docAssicurazione4 = useSelector(state => state.dataReducer.documentiPdf.docAssicurazione4);
    const accordions = useSelector(state => state.dataReducer.documentiPdf.accordions);

    const sliderImportoRef = useRef(null);
    const sliderMesiRef = useRef(null);
    
    const loadingPreventivo = useSelector(state => state.dataReducer.load.loadingPreventivo);
    const loadingStep = useSelector(state => state.dataReducer.load.loadingStep);

    const erroriPreventivo = useSelector(state => state.dataReducer.errorePreventivo.dati);
    const errorMessageImporto = erroriPreventivo && typeof erroriPreventivo == "object" ? erroriPreventivo.map(errore => {
        if(errore.errorCode === 'importo'){
            return errore.errorMessage;
        }
        return null;
    }) : null;

    const datiPreventivo = useSelector(state => state.dataReducer.modello.datiPratica);
    const tanState = datiPreventivo.tan;
    const taegState = datiPreventivo.taeg;
    const importoRataState = datiPreventivo.rata;

    const [importo,setImporto] = useState(datiPreventivo.importo || 2000);
    const [importoLabel,setImportoLabel] = useState(datiPreventivo.importo || 2000);
    const [numeroRate,setNumeroRate] = useState(datiPreventivo.numeroRate || 12);
    const [progetto,setProgetto] = useState( datiPreventivo.progetto || null);
    // const [assicurazione,setAssicurazione] = useState(datiPreventivo.assicurazione || false);
    const [visibleModal,setVisibleModal] = useState(false);
    const [sliderToBeFocused,setSliderToBeFocused] = useState(null);
    const dispatch = useDispatch();

    const [form] = Form.useForm();
    const assicurazione = Form.useWatch('assicurazione', form);

    useEffect(() => {
        if (!datiPreventivo) return;
            form.setFieldsValue({
            ...datiPreventivo,
            assicurazione: typeof datiPreventivo.assicurazione === 'boolean'
                ? datiPreventivo.assicurazione
                : false,
        });
        setImporto(datiPreventivo.importo);
        setImportoLabel(datiPreventivo.importo);
        setNumeroRate(datiPreventivo.numeroRate);
    }, [datiPreventivo, datiPreventivo.importo, datiPreventivo.numeroRate]);

    useEffect(() => {
        if (!loadingPreventivo) {
            sliderToBeFocused && sliderToBeFocused.current.focus();
            setSliderToBeFocused(null);
        }
    }, [loadingPreventivo]);

    const fullYear = () => {
        return new Date().getFullYear();
    }

    const { Option } = Select;
    const marks1 = {
        2000: '2.000€',
        30000: '30.000€'
    };
    const marks2 = {
        12: '12',
        24: '24',
        36: '36',
        48: '48',
        60: '60',
        72: '72',
        84: '84'
    };

    function formatter(value) {
        return `${value}€`;
    }

    function onFinish(values) {
        dispatch({type: actionTypes.LOADING_TRUE});
        if(uuid === null){
            dispatch(inserimentoPreventivo(datiPreventivo,codiceBroker,stepCorrente,apiPath,numPratica));
        }else{
            dispatch({type: actionTypes.STEP_AVANTI});
            dispatch({type: actionTypes.LOADING_FALSE});

        }
    };

    function cambioImporto(value){
        if (value !== importo) {
            dispatch({type: actionTypes.LOADING_PREVENTIVO_TRUE});
            setImporto(value);
            dispatch(getCalcoloPreventivo(value,numeroRate,progetto, assicurazione, codiceBroker,apiPath));
            setSliderToBeFocused(sliderImportoRef);
        }
    }
    function cambioMesi(value){
        if (value !== numeroRate) {
            dispatch({type: actionTypes.LOADING_PREVENTIVO_TRUE});
            setNumeroRate(value);
            dispatch(getCalcoloPreventivo(importo,value,progetto, assicurazione, codiceBroker,apiPath));
            setSliderToBeFocused(sliderMesiRef);
        }
    }
    function cambioProgetto(value){
        if (value) {
            dispatch({type: actionTypes.LOADING_PREVENTIVO_TRUE});
            setProgetto(value);
            dispatch(getCalcoloPreventivo(importo,numeroRate,value, assicurazione, codiceBroker,apiPath));
        }
    }
    function cambioAssicurazione(value) {
        dispatch({ type: actionTypes.LOADING_PREVENTIVO_TRUE });
        dispatch(getCalcoloPreventivo(importo, numeroRate, progetto, value, codiceBroker, apiPath));
    }   
    function showModal(){
        setVisibleModal(!visibleModal);
    }


    function applicaSeparatore(importoNumerico){  
        var importo = importoNumerico.toString();  
        if(importo.length>3){  
          importo = importo.split('',importo.length).reverse().join('').replace(/([0-9]{3})/g,'$1.');  
          importo = importo.split('',importo.length).reverse().join('');  
        }  
        return importo;  
    }  

    function cambioValoreImportoFE(value){
        setImportoLabel(value);
    }

    return(

        <div className={`${stylePreventivatore.Container} ${stylesForm.Form}`}>
                <Form form={form} name={`preventivo`} onFinish={onFinish}>

                    <div className={`${stylePreventivatore.ContentText} ${stylePreventivatore.White}`}>
                        
                        <div className={stylePreventivatore.Titolo}>
                            <div className={stylePreventivatore.Logo}><a href={linkHome} target="_blank" rel="noopener noreferrer"><Logo/></a></div>
                            <h1>Prestito <span className={stylePreventivatore.spanTitolo}>Prestipay</span> </h1>
                        </div>

                        <div className={stylePreventivatore.Rapporti}>

                            <div className={stylePreventivatore.singoloRapporto}>

                                <p className={stylePreventivatore.titoloSlider}>Di quale importo hai bisogno?</p>
                                <p className={stylePreventivatore.infoSlider}>{applicaSeparatore(importoLabel)}€</p>
                                <Form.Item name='importo' help={errorMessageImporto ? errorMessageImporto : null }
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Scegli l\'importo',
                                        }
                                    ]}
                                    >
                                    <Slider ref={sliderImportoRef} onChange={cambioValoreImportoFE} onAfterChange={cambioImporto} marks={marks1} step={250} max={30000} min={2000} tooltip={{open: false, formatter: formatter}} disabled={loadingPreventivo} />
                                </Form.Item>
                            </div>

                            <div className={stylePreventivatore.singoloRapporto}>

                                <p className={stylePreventivatore.titoloSlider}>In quanti mesi vuoi rimborsare?</p>
                                <p className={stylePreventivatore.infoSlider}>{numeroRate} mesi</p>
                                <Form.Item name='numeroRate'
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Scegli i mesi di rimborso',
                                        }
                                    ]}
                                    >
                                    <Slider ref={sliderMesiRef} onAfterChange={cambioMesi} tooltip={{open: false}}  marks={marks2} step={12} max={84} min={12}  disabled={loadingPreventivo} />
                                </Form.Item>
                            </div>

                            <div className={stylePreventivatore.singoloRapporto}>
                                <p className={stylePreventivatore.titoloSlider}>Quale progetto vuoi realizzare ?</p>
                                <Form.Item name="progetto"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Scegli il progetto da realizzare',
                                        }
                                    ]}
                                >
                                    <Select onChange={cambioProgetto} disabled={loadingPreventivo} placeholder="Progetto*">
                                        <Option value="">Progetto*</Option>
                                        <Option value="AUN">Auto</Option>
                                        <Option value="CAM">Caravan/Camper</Option>
                                        <Option value="VAC">Viaggi e Vacanze</Option>
                                        <Option value="MOT">Moto</Option>
                                        <Option value="ELE">Elettrodomestici/Elettronica</Option>
                                        <Option value="RIS">Spese Ristrutturazione Casa</Option>
                                        <Option value="MOB">Arredamento</Option>
                                        <Option value="LIQ">Altri Progetti</Option>
                                        <Option value="SST">Studio</Option>
                                        <Option value="SSA">Cure e Interventi Sanitari</Option>
                                    </Select>
                                </Form.Item>
                            </div>

                        </div>


                        <div className={stylePreventivatore.RapportiResponsive}>

                            <Collapse  defaultActiveKey={['1']} expandIcon={({ isActive }) =>  isActive ? <Immagine urlImage={'/preventivatore/up.svg'} name="CLOSE" class={stylePreventivatore.immagineCollapse}  /> : <Immagine urlImage={'/preventivatore/down.svg'} name="OPEN" class={stylePreventivatore.immagineCollapse} />  }>
                                <Panel header='Modifica la configurazione' key={'1'} >
                                    <div className={stylePreventivatore.singoloRapporto}>

                                        <p className={stylePreventivatore.titoloSlider}>Di quale importo hai bisogno?</p>
                                        <p className={stylePreventivatore.infoSlider}>{applicaSeparatore(importoLabel)}€</p>
                                        <Form.Item name='importo' help={errorMessageImporto ? errorMessageImporto : null }
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Scegli l\'importo',
                                                }
                                            ]}
                                            >
                                            <Slider ref={sliderImportoRef} onChange={cambioValoreImportoFE} onAfterChange={cambioImporto} tooltip={{open: false, formatter: formatter}} marks={marks1} step={250} max={30000} min={2000}  disabled={loadingPreventivo} />
                                        </Form.Item>
                                    </div>

                                    <div className={stylePreventivatore.singoloRapporto}>

                                        <p className={stylePreventivatore.titoloSlider}>In quanti mesi vuoi rimborsare?</p>
                                        <p className={stylePreventivatore.infoSlider}>{numeroRate} mesi</p>
                                        <Form.Item name='numeroRate'
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Scegli i mesi di rimborso',
                                                }
                                            ]}
                                            >
                                            <Slider ref={sliderMesiRef} onAfterChange={cambioMesi} tooltip={{open: false}}  marks={marks2} step={12} max={84} min={12}  disabled={loadingPreventivo} />
                                        </Form.Item>
                                    </div>

                                    <div className={stylePreventivatore.singoloRapporto}>
                                        <p className={stylePreventivatore.titoloSlider}>Quale progetto vuoi realizzare ?</p>
                                        <Form.Item name="progetto"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Scegli il progetto da realizzare',
                                                }
                                            ]}
                                            >
                                            <Select placeholder="Progetto*" name='progetto' onChange={cambioProgetto} disabled={loadingPreventivo} >
                                                <Option value="">Progetto*</Option>
                                                <Option value="AUN">Auto</Option>
                                                <Option value="CAM">Caravan/Camper</Option>
                                                <Option value="VAC">Viaggi e Vacanze</Option>
                                                <Option value="MOT">Moto</Option>
                                                <Option value="ELE">Elettrodomestici/Elettronica</Option>
                                                <Option value="RIS">Spese Ristrutturazione Casa</Option>
                                                <Option value="MOB">Arredamento</Option>
                                                <Option value="LIQ">Altri Progetti</Option>
                                                <Option value="SST">Studio</Option>
                                                <Option value="SSA">Cure e Interventi Sanitari</Option>
                                            </Select>
                                        </Form.Item>
                                    </div>
                                </Panel>
                            </Collapse>
                        </div>


                    </div>

                    <div className={`${stylePreventivatore.ContentText} ${stylePreventivatore.Gradient}`}>

                        <div className={stylePreventivatore.Assicurazione}>

                            <div className={stylePreventivatore.AssicurazioneLeft}>
                                <Immagine urlImage={'insurance.svg'} name='assicurazione' />
                            </div>

                            <div className={stylePreventivatore.AssicurazioneRight}>
                                <div className={stylePreventivatore.AssicurazioneTooltip}>
                                    <h1 style={{ margin: 0 }}>Vuoi aggiungere un'assicurazione facoltativa?</h1>
                                    <Immagine
                                        urlImage={'petroil.svg'}
                                        name="info"
                                        class={stylePreventivatore.openInfo}
                                        clicked={showModal}
                                    />
                                </div>

                                <Form.Item name='assicurazione' valuePropName='checked'>
                                    <Switch disabled={loadingPreventivo} checkedChildren="SI" unCheckedChildren="NO" onChange={cambioAssicurazione} />
                                    
                                </Form.Item>
                            </div>
                        </div>

                        <Preventivo spin={loadingPreventivo} loadingStep={loadingStep} importo={importo} numeroRate={numeroRate} assicurazione={assicurazione} tan={tanState} taeg={taegState} rata={importoRataState} />

                        <div className={stylePreventivatore.Info}>
                            { accordions && accordions.length > 0 ? (
                                <Collapse className={stylePreventivatore.Accordions} defaultActiveKey={['0','1']} ghost expandIcon={({ isActive }) =>  isActive ? <Immagine urlImage={'/preventivatore/up-white.svg'} name="CLOSE" class={stylePreventivatore.immagineCollapse}  /> : <Immagine urlImage={'/preventivatore/down-white.svg'} name="OPEN" class={stylePreventivatore.immagineCollapse} />  }>
                                    {
                                        accordions && accordions.length > 0 ? accordions.map((singleAccordion, key) => {
                                            return (
                                                <Panel className={stylePreventivatore.SingleAccordion} header={singleAccordion.title} key={key}>
                                                    {parse(singleAccordion.text)}
                                                </Panel>
                                            )
                                        }) : null
                                    }
                                </Collapse>
                            ) : null }
                            <p>Altre informazioni utili:</p>
                            <div className={stylePreventivatore.Links}>
                                {
                                    documentiPreventivatore && documentiPreventivatore.map(link => {
                                        if(link.url){
                                            return (
                                                <div key={link.url}>
                                                    <a className={stylePreventivatore.singoloLink} href={link.url} target="_blank" rel="noopener noreferrer">{link.label} <Immagine urlImage={'preventivatore/right.svg'} name={link.label}/></a>
                                                    <div className={stylePreventivatore.Clear}></div>
                                                </div>
                                            );
                                        }else{
                                            return null;
                                        }
                                    })
                                }
                            </div>
                        </div>

                        <div className={stylePreventivatore.Clear}></div>

                    </div>

                    <div className={stylePreventivatore.footerContent}>
                        <div className={stylePreventivatore.footerLeft}>
                            <p>© {fullYear()} Prestipay S.p.A. - Tutti i diritti riservati</p>
                        </div>
                        <div className={stylePreventivatore.footerRight}>
                            <div className={stylePreventivatore.listaLinkFooter}>
                                <a className={stylePreventivatore.singoloLinkFooter} href={linkTrasparenza} target="_blank" rel="noopener noreferrer">Trasparenza</a>
                                <a className={stylePreventivatore.singoloLinkFooter} href={linkSicurezza} target="_blank" rel="noopener noreferrer">Sicurezza</a>
                                <a className={stylePreventivatore.singoloLinkFooter} href={linkCookies} target="_blank" rel="noopener noreferrer">Cookies</a>
                                <a className={stylePreventivatore.singoloLinkFooter} href={linkPrivacy} target="_blank" rel="noopener noreferrer">Privacy</a>
                            </div>
                        </div>
                        <div className={stylePreventivatore.Clear}></div>
                    </div>

                </Form>


            <Modal
                onCancel={showModal}
                open={visibleModal}
                closeIcon={<Immagine urlImage={'close-modal.svg'} name='close' />}
            >
                <h2 className={stylePreventivatore.modalTitle}>Vuoi aggiungere un’assicurazione facoltativa?</h2>
                <p className={stylePreventivatore.modalText}>Puoi sottoscrivere una polizza offerta da MetLife Italia che ha lo scopo di proteggere te e i tuoi cari in caso di decesso o gravi malattie, garantendo il rimborso di un importo pari al capitale iniziale del finanziamento (per ulteriori dettagli consulta il set informativo).</p>
                <p>Ti ricordiamo che la polizza è facoltativa e non indispensabile per ottenere il finanziamento alle condizioni proposte. Prima di proseguire ti invitiamo a prendere visione del <a href={docAssicurazione1} target="_blank" rel="noopener noreferrer">set informativo</a> che riporta le caratteristiche, le limitazioni, le <a href={docAssicurazione2} target="_blank" rel="noopener noreferrer">esclusioni</a> e le <a href={docAssicurazione3} target="_blank" rel="noopener noreferrer">modalità per recedere</a> nei primi 60 giorni dalla polizza. Indicaci il/i beneficiario/i della polizza (per la garanzia decesso) tramite l’apposito <a href={docAssicurazione4} target="_blank" rel="noopener noreferrer">modulo</a>, in alternativa i beneficiari saranno i tuoi eredi.</p>
            </Modal>


        </div>

    )
}

export default Preventivatore;